import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { KNOW_IT_OWLS_LOGO } from "@/data/products";

export default function Cancel() {
  return (
    <div
      data-testid="cancel-page"
      className="min-h-screen grid-paper flex items-center justify-center px-4 py-16"
    >
      <div className="max-w-xl w-full border-2 border-[#111] bg-[var(--st-cream)] shadow-brutal p-8 text-center">
        <img src={KNOW_IT_OWLS_LOGO} alt="The Know It Owls" className="h-20 mx-auto" />
        <XCircle size={36} className="mx-auto mt-4 text-[var(--st-maroon)]" />
        <p className="mt-3 font-display uppercase text-3xl text-[var(--st-green)]">
          Checkout Cancelled
        </p>
        <p className="mt-2 font-body text-sm text-[var(--st-fg)]/80">
          No worries — your cart is saved. Pick up where you left off.
        </p>
        <div className="mt-8 flex justify-center">
          <Link to="/" data-testid="cancel-back" className="btn-brutal">
            <ArrowLeft size={14} /> Back to the Shop
          </Link>
        </div>
      </div>
    </div>
  );
}
